<div class="content-loaf">
  <div class="status-edit-info">
    ①施設での対応・利用について○・×のいずれかを選択 [必須]<br />
    ②必要に応じてコメントを入力 [任意] <br />
    ③更新ボタンをクリック
  </div>

  <div class="table-responsive">
    <table class="table table-default reference-table table-bordered" style="margin-bottom: 0;">
      <thead>
        <tr class="center-block">
          <th colspan="2" class="institution-name"><span [innerHTML]="clinicStatus.institutionName.split('CRLF').join('<br />')"></span></th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <th style="width: 150px;">院長名</th>
          <td style="width: auto;">{{clinicStatus.directorName}}</td>
        </tr>

        <tr>
          <th>診療科目</th>
          <td>
            <span class="d-none d-md-block" [innerHTML]="clinicStatus.medicalCoursesName.split('CRLF').join('・')"></span>
            <span class="d-block d-md-none" [innerHTML]="clinicStatus.medicalCoursesName.split('CRLF').join('<br />')"></span>
          </td>
        </tr>

        <tr>
          <th>住所</th>
          <td>{{clinicStatus.address}}</td>
        </tr>

        <tr>
          <th>ＴＥＬ</th>
          <td>{{clinicStatus.tel}}</td>
        </tr>

        <tr>
          <th>ＦＡＸ</th>
          <td>{{clinicStatus.fax}}</td>
        </tr>
      </tbody>
    </table>

    <table class="table table-default reference-table table-bordered">
      <tbody>
        <tr class="center-block">
          <td class="symbol">
            <div class="row">
              <div class="col-7">
                <mat-button-toggle-group name="consultation" aria-label="consultation" [(ngModel)]="clinicStatus.consultation">
                  <mat-button-toggle class="possible-btn" [value]="1">○</mat-button-toggle>
                  <mat-button-toggle class="impossible-btn" [value]="0">✕</mat-button-toggle>
                </mat-button-toggle-group>
                <div class="required-message" *ngIf="clinicStatus.consultation === 2 && !isValid">※ 選択してください</div>
              </div>
              <div class="col-5 text-left">
                <label for="consultation">診察</label>
              </div>
            </div>
          </td>

          <td class="symbol">
            <div class="row">
              <div class="col-7">
                <mat-button-toggle-group name="electricity" aria-label="electricity" [(ngModel)]="clinicStatus.electricity">
                  <mat-button-toggle class="possible-btn" [value]="1">○</mat-button-toggle>
                  <mat-button-toggle class="impossible-btn" [value]="0">✕</mat-button-toggle>
                </mat-button-toggle-group>
                <div class="required-message" *ngIf="clinicStatus.electricity === 2 && !isValid">※ 選択してください</div>
              </div>
              <div class="col-5 text-left">
                <label for="electricity">電気</label>
              </div>
            </div>
          </td>
        </tr>

        <tr class="center-block">
          <td class="symbol">
            <div class="row">
              <div class="col-7">
                <mat-button-toggle-group name="waterSupply" aria-label="waterSupply" [(ngModel)]="clinicStatus.waterSupply">
                  <mat-button-toggle class="possible-btn" [value]="1">○</mat-button-toggle>
                  <mat-button-toggle class="impossible-btn" [value]="0">✕</mat-button-toggle>
                </mat-button-toggle-group>
                <div class="required-message" *ngIf="clinicStatus.waterSupply === 2 && !isValid">※ 選択してください</div>
              </div>
              <div class="col-5 text-left">
                <label for="waterSupply">水道</label>
              </div>
            </div>
          </td>

          <td class="symbol">
            <div class="row">
              <div class="col-7">
                <mat-button-toggle-group name="phone" aria-label="phone" [(ngModel)]="clinicStatus.phone">
                  <mat-button-toggle class="possible-btn" [value]="1">○</mat-button-toggle>
                  <mat-button-toggle class="impossible-btn" [value]="0">✕</mat-button-toggle>
                </mat-button-toggle-group>
                <div class="required-message" *ngIf="clinicStatus.phone === 2 && !isValid">※ 選択してください</div>
              </div>
              <div class="col-5 text-left">
                <label for="phone">電話</label>
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td colspan="12">
            <textarea name="comment" rows="5" [(ngModel)]="clinicStatus.comment" placeholder="被災状況などのコメントを入力してください。"></textarea>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row">
    <div class="col-lg-8 col-md-7 mb-2 explanation-text">
      ※更新を取消する場合は、キャンセルボタンをクリック
    </div>
    <div class="col-lg-4 col-md-5 right-block">
      <button name="update" class="btn btn-primary btn-primary-gradient mr-2" (click)="update()">更　新</button>
      <button class="btn btn-primary btn-primary-gradient" routerLink="/clinicstatuslist">キャンセル</button>
    </div>
  </div>
</div>
